// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"g_p ml-3","matrix-table--pad4":"g_q ml-5","matrix-table__title":"g_r","matrix-table__true":"g_s","matrix-table__false":"g_t"};